import type { FaqCategory, FaqListItemDto } from '@/types/api/faq';

/** 화면에 노출하는 FAQ 카테고리 순서 (고정) */
export const FAQ_CATEGORY_ORDER: readonly FaqCategory[] = ['STUDENT', 'MASTER'];

export interface FaqCategoryGroup {
  category: FaqCategory;
  faqs: FaqListItemDto[];
}

/**
 * FAQ 목록을 고정된 카테고리 순서(STUDENT → MASTER)로 묶는다.
 * 항목이 없는 카테고리는 제외하며, 카테고리 내 순서는 API 응답(등록 순)을 유지한다.
 */
export function groupFaqsByCategory(faqs: FaqListItemDto[]): FaqCategoryGroup[] {
  return FAQ_CATEGORY_ORDER.map((category) => ({
    category,
    faqs: faqs.filter((faq) => faq.category === category),
  })).filter((group) => group.faqs.length > 0);
}
